import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, KeepAlive as _KeepAlive, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/head_tab_blue.svg'
import _imports_1 from '@/assets/images/head_link_video.svg'
import _imports_2 from '@/assets/images/title_yn.svg'
import _imports_3 from '@/assets/images/il.svg'
import _imports_4 from '@/assets/images/text_image.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("noscript", null, "\n<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-ND4GVCB\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>\n", -1)
const _hoisted_2 = { class: "tmstart_link_wrapper" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "-Logo",
  src: _imports_0,
  alt: "夢ナビ"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", { href: "https://tmstart.yumenavi.info/video/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "-Logo",
    src: _imports_1,
    alt: "夢ナビ"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"tmstart_wrapper\"><div class=\"tmstart_header\"><img class=\"imageLeft\" src=\"" + _imports_2 + "\" alt=\"夢ナビ\"><img class=\"imageRight\" src=\"" + _imports_3 + "\" alt=\"夢ナビ\"></div><div class=\"tmstart_bottom\"><img src=\"" + _imports_4 + "\" alt=\"夢ナビ\"></div><div class=\"tmstart_button_wrapper\"><a class=\"tmstart_color1\" href=\"./result.html?Kw=音楽&amp;SerKbn=2\">#音楽</a><a class=\"tmstart_color2\" href=\"./result.html?Kw=ゲーム&amp;SerKbn=2\">#ゲーム</a><a class=\"tmstart_color3\" href=\"./result.html?Kw=アニメ&amp;SerKbn=2\">#アニメ</a><a class=\"tmstart_color3\" href=\"./result.html?Kw=スポーツ&amp;SerKbn=2\">#スポーツ</a><a class=\"tmstart_color4\" href=\"./result.html?Kw=ファッション&amp;SerKbn=2\">#ファッション</a><a class=\"tmstart_color2\" href=\"./result.html?Kw=心理学&amp;SerKbn=2\">#心理学</a><a class=\"tmstart_color2\" href=\"./result.html?Kw=宇宙&amp;SerKbn=2\">#宇宙</a><a class=\"tmstart_color3\" href=\"./result.html?Kw=お菓子&amp;SerKbn=2\">#お菓子</a><a class=\"tmstart_color1\" href=\"./result.html?Kw=医療&amp;SerKbn=2\">#医療</a><a class=\"tmstart_color3\" href=\"./result.html?Kw=薬&amp;SerKbn=2\">#薬</a><a class=\"tmstart_color1\" href=\"./result.html?Kw=映画&amp;SerKbn=2\">#映画</a><a class=\"tmstart_color4\" href=\"./result.html?Kw=人工知能&amp;SerKbn=2\">#人工知能</a></div><div class=\"tmstart_message\">※検索時には「#（シャープ）」の入力は不要です。</div></div>", 1)
const _hoisted_8 = { class: "l-main" }
const _hoisted_9 = {
  id: "jsPageSearch",
  method: "get",
  action: "./result.html"
}
const _hoisted_10 = { class: "p-result__filter" }
const _hoisted_11 = { class: "p-result__filter__inner" }
const _hoisted_12 = {
  key: 0,
  class: "p-result__filter__input"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", { id: "input_multidt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "-WordOfInterest icon_teacher" }, "検索条件")
], -1)
const _hoisted_14 = { id: "input_multidd" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  id: "input_worddt",
  style: {"display":"none"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "-WordOfInterest icon_word" }, "関心ワード", -1)
const _hoisted_18 = { class: "-PerfectMatching" }
const _hoisted_19 = {
  class: "search_form",
  id: "input_worddd",
  style: {"display":"none"}
}
const _hoisted_20 = {
  key: 1,
  class: "p-result__filter__input"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "-WordOfInterest icon_univ" }, "大学名")
], -1)
const _hoisted_22 = { class: "search_form" }
const _hoisted_23 = {
  key: 2,
  class: "p-result__filter__input"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "-WordOfInterest icon_faculty" }, "学部・学科名")
], -1)
const _hoisted_25 = { class: "search_form" }
const _hoisted_26 = {
  key: 3,
  class: "p-result__filter__input"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "-WordOfInterest icon_teacher" }, "先生名")
], -1)
const _hoisted_28 = { class: "search_form" }
const _hoisted_29 = {
  key: 4,
  class: "p-result__filter__input"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "-WordOfInterest icon_word" }, "関心ワード", -1)
const _hoisted_31 = { class: "-PerfectMatching" }
const _hoisted_32 = { class: "search_form" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("検索条件変更")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "u-icon-glass" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  class: "c-button-filter u-spOnly",
  id: "js-modal__opener",
  type: "button"
}, [
  /*#__PURE__*/_createTextVNode("検索条件変更"),
  /*#__PURE__*/_createElementVNode("div", { class: "u-icon-glass" }, [
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1)
const _hoisted_37 = { class: "p-result__filterSearch__inner" }
const _hoisted_38 = { class: "p-result__filterSearch__check" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("学問分野で絞り込み")
const _hoisted_40 = { class: "-FilterGakumon" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("学問分野")
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { id: "js-checkedText" }, null, -1)
const _hoisted_43 = { class: "u-flexSpaceBetween" }
const _hoisted_44 = { class: "p-result__decisonArea" }
const _hoisted_45 = {
  key: 0,
  class: "p-result__usedsearchword"
}
const _hoisted_46 = { class: "usword" }
const _hoisted_47 = {
  key: 1,
  class: "p-result__usedsearchword__nodata"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "p-result__number" }
const _hoisted_51 = { class: "p-result__number__inner" }
const _hoisted_52 = { class: "-Search" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("検索結果：")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("件")
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"c-modalFilterSearch__wrapper\" style=\"display:none;\"><div class=\"c-modalFilterSearch__overlay\"><div class=\"c-modalFilterSearch__header\"><h4>絞り込み検索</h4><button class=\"close_modal\" type=\"button\"><span class=\"u-icon-times\"></span></button></div><div class=\"c-modalFilterSearch__content\"></div></div></div><button class=\"c-button-scrollFilter\" id=\"js-scrollFilter\" type=\"button\">検索条件変更<div class=\"u-icon-glass\"><span></span></div></button>", 2)

export function render(_ctx: any,_cache: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppFilterInput = _resolveComponent("AppFilterInput")!
  const _component_AppFilterGakumonCheck = _resolveComponent("AppFilterGakumonCheck")!
  const _component_AppFilterRitsuKubun = _resolveComponent("AppFilterRitsuKubun")!
  const _component_AppFilterArea = _resolveComponent("AppFilterArea")!
  const _component_AppFilterSDGs = _resolveComponent("AppFilterSDGs")!
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_vue_element_loading = _resolveComponent("vue-element-loading")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (this.isTmstart)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", {
              href: `${_ctx.consts.yumenaviinfo}vue/result.html?tmstart=1`
            }, _hoisted_5, 8, _hoisted_3),
            _hoisted_6
          ]),
          _hoisted_7
        ], 64))
      : (_openBlock(), _createBlock(_component_AppHeader, { key: 1 })),
    _createElementVNode("main", _hoisted_8, [
      _createElementVNode("form", _hoisted_9, [
        _createElementVNode("section", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.SearchMode.includes('Multi'))
              ? (_openBlock(), _createElementBlock("dl", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("dd", _hoisted_14, [
                    _createElementVNode("input", {
                      class: "c-input__text",
                      id: "js-multiWords",
                      type: "text",
                      placeholder: "検索条件で探す",
                      value: _ctx.searchMixValues,
                      disabled: "true"
                    }, null, 8, _hoisted_15)
                  ]),
                  _createElementVNode("dt", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("p", _hoisted_18, [
                      _createElementVNode("a", {
                        href: "",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exactMatch && _ctx.exactMatch(...args)), ["prevent","stop"]))
                      }, "完全一致で検索")
                    ])
                  ]),
                  _createElementVNode("dd", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      class: "c-input__text",
                      id: "js-RelatedWords",
                      type: "text",
                      placeholder: "関心ワードで探す",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Kw) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.Kw]
                    ]),
                    _createElementVNode("a", {
                      class: "search_submit",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmit && _ctx.onClickSubmit(...args)))
                    })
                  ])
                ]))
              : (_ctx.SearchMode.includes('Dg'))
                ? (_openBlock(), _createElementBlock("dl", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("dd", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        class: "c-input__text",
                        type: "text",
                        placeholder: "大学名で探す",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Dg) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.Dg]
                      ]),
                      _createElementVNode("a", {
                        class: "search_submit",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmit && _ctx.onClickSubmit(...args)))
                      })
                    ])
                  ]))
                : (_ctx.SearchMode.includes('Gb'))
                  ? (_openBlock(), _createElementBlock("dl", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("dd", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          class: "c-input__text",
                          type: "text",
                          placeholder: "学部・学科名で探す",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.Gb) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.Gb]
                        ]),
                        _createElementVNode("a", {
                          class: "search_submit",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmit && _ctx.onClickSubmit(...args)))
                        })
                      ])
                    ]))
                  : (_ctx.SearchMode.includes('Kj'))
                    ? (_openBlock(), _createElementBlock("dl", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("dd", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            class: "c-input__text",
                            type: "text",
                            placeholder: "先生名で探す",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.Kj) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.Kj]
                          ]),
                          _createElementVNode("a", {
                            class: "search_submit",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmit && _ctx.onClickSubmit(...args)))
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("dl", _hoisted_29, [
                        _createElementVNode("dt", null, [
                          _hoisted_30,
                          _createElementVNode("p", _hoisted_31, [
                            _createElementVNode("a", {
                              href: "",
                              onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exactMatch && _ctx.exactMatch(...args)), ["prevent","stop"]))
                            }, "完全一致で検索")
                          ])
                        ]),
                        _createElementVNode("dd", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            class: "c-input__text",
                            id: "js-RelatedWords",
                            type: "text",
                            placeholder: "関心ワードで探す",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.Kw) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.Kw]
                          ]),
                          _createElementVNode("a", {
                            class: "search_submit",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmit && _ctx.onClickSubmit(...args)))
                          })
                        ])
                      ])),
            _createElementVNode("button", {
              class: _normalizeClass(["c-button-filter u-pcOnly", { 'js-active': _ctx.isFilterSearchOpen }]),
              id: "js-toggle",
              type: "button",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onClickFilterSearchToggle && _ctx.onClickFilterSearchToggle(...args)))
            }, _hoisted_35, 2),
            _hoisted_36
          ])
        ]),
        _createElementVNode("section", {
          class: _normalizeClass(["p-result__filterSearch", { 'js-open': _ctx.isFilterSearchOpen }]),
          id: "js-toggleContent"
        }, [
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_AppFilterInput, {
              relatedSearch: this.relatedsearchwords,
              Kw: _ctx.Kw,
              "onUpdate:Kw": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.Kw) = $event)),
              Dg: _ctx.Dg,
              "onUpdate:Dg": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.Dg) = $event)),
              Gb: _ctx.Gb,
              "onUpdate:Gb": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.Gb) = $event)),
              Kj: _ctx.Kj,
              "onUpdate:Kj": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.Kj) = $event))
            }, null, 8, ["relatedSearch", "Kw", "Dg", "Gb", "Kj"]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", {
                class: _normalizeClass(["-FilterGakumonSp u-spOnly", { 'js-active': _ctx.isGakumonOpen }]),
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onClickGakumonToggle && _ctx.onClickGakumonToggle(...args)))
              }, [
                _hoisted_39,
                _createElementVNode("span", {
                  class: _normalizeClass(["u-icon-plus", { 'js-active': _ctx.isGakumonOpen }])
                }, null, 2)
              ], 2),
              _createElementVNode("dl", _hoisted_40, [
                _createElementVNode("dt", null, [
                  _hoisted_41,
                  _createElementVNode("span", {
                    class: _normalizeClass(["u-icon-plus u-pcOnly", { 'js-active': _ctx.isGakumonOpen }]),
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onClickGakumonToggle && _ctx.onClickGakumonToggle(...args)))
                  }, null, 2),
                  _hoisted_42
                ]),
                _createElementVNode("dd", {
                  id: "js-toggleGakumonCheckContent",
                  class: _normalizeClass({ 'js-open': _ctx.isGakumonOpen })
                }, [
                  _createVNode(_component_AppFilterGakumonCheck, {
                    gakumonUpdate: _ctx.gakumonValues,
                    "onUpdate:gakumonUpdate": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.gakumonValues) = $event)),
                    optionsGakumon: _ctx.gakumonData
                  }, null, 8, ["gakumonUpdate", "optionsGakumon"])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_AppFilterRitsuKubun, {
                  ritsuKubunUpdate: _ctx.ritsuKubunValues,
                  "onUpdate:ritsuKubunUpdate": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.ritsuKubunValues) = $event)),
                  optionsRitsuKubun: _ctx.ritsuKubunData
                }, null, 8, ["ritsuKubunUpdate", "optionsRitsuKubun"]),
                _createVNode(_component_AppFilterArea, {
                  areaUpdate: _ctx.areaValues,
                  "onUpdate:areaUpdate": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.areaValues) = $event)),
                  optionsArea: _ctx.areaData
                }, null, 8, ["areaUpdate", "optionsArea"])
              ]),
              _createVNode(_component_AppFilterSDGs, {
                SDGsUpdate: _ctx.SDGsValues,
                "onUpdate:SDGsUpdate": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.SDGsValues) = $event)),
                optionsSDGs: _ctx.SDGsData
              }, null, 8, ["SDGsUpdate", "optionsSDGs"])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "c-button-close u-pcOnly",
                type: "button",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onClickFilterSearchToggle && _ctx.onClickFilterSearchToggle(...args)))
              }, "閉じる"),
              _createElementVNode("button", {
                class: "c-button-clear",
                type: "reset",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onClickReset && _ctx.onClickReset(...args)))
              }, "条件クリア"),
              _createElementVNode("button", {
                class: "c-button-search",
                type: "button",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.onClickSubmit && _ctx.onClickSubmit(...args)))
              }, "この条件で検索")
            ])
          ])
        ], 2),
        (this.usedsearchword)
          ? (_openBlock(), _createElementBlock("section", _hoisted_45, [
              _createElementVNode("p", _hoisted_46, _toDisplayString(this.searchKw) + "と言えば 「" + _toDisplayString(this.usedsearchword) + "」 ですよね。", 1)
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_47, _hoisted_49)),
        _createElementVNode("section", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("p", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("span", null, _toDisplayString(this.searchTotal), 1),
              _hoisted_54
            ])
          ])
        ]),
        (_openBlock(), _createBlock(_KeepAlive, null, [
          _createVNode(_component_AppSearch, {
            searchResults: _ctx.displist,
            lectureParam: _ctx.lectureParam
          }, null, 8, ["searchResults", "lectureParam"])
        ], 1024)),
        _hoisted_55,
        _withDirectives(_createElementVNode("input", {
          id: "js-SerKbn",
          type: "hidden",
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.SerKbn) = $event)),
          name: "SerKbn"
        }, null, 512), [
          [_vModelText, _ctx.SerKbn]
        ]),
        _createVNode(_component_vue_element_loading, {
          active: _ctx.loadingshow,
          color: "rgba(110, 185, 43, .4)",
          size: "120",
          duration: "1.0",
          "is-full-screen": ""
        }, null, 8, ["active"])
      ])
    ]),
    (this.finishCount == this.searchTotal)
      ? (_openBlock(), _createBlock(_component_AppFooter, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}